import { type ComponentProps } from 'react';
import { css } from '@emotion/react';
import * as Sentry from '@sentry/react';
import { shell, useIpcShellProvider } from '@frontend/shell-utils';
import { theme } from '@frontend/theme';

type Props = ComponentProps<Sentry.FallbackRender>;

const ErrorDisplay = ({ error, eventId: _eventId, componentStack: _stack }: Props) => {
  const { resetConnection } = useIpcShellProvider();
  const close = () => {
    if (!shell.isShell) {
      return;
    }
    resetConnection();
    shell.emit?.('notifications:empty', undefined);
    shell.emit?.('notifications:hide', undefined);
  };

  const handleDismiss = () => {
    close();
  };
  return (
    <main
      css={css`
        padding: ${theme.spacing(2)};
      `}
    >
      <div
        css={css`
          position: relative;
          margin-bottom: ${theme.spacing(0.5)};
          background: ${theme.colors.white};
          border-radius: ${theme.borderRadius.medium};
          box-shadow: ${theme.shadows.heavy};
          width: 350px;
          overflow: hidden;
        `}
      >
        <div
          css={css`
            position: relative;
          `}
        >
          <header
            css={css`
              -webkit-user-select: none;
              user-select: none;
              -webkit-app-region: drag;
              align-items: center;
              background: ${theme.colors.neutral10};
              border-radius: 8px 8px 0 0;
              display: inline-grid;
              grid-template-columns: 1fr 1fr 1fr;
              width: 100%;
              padding: ${theme.spacing(1.5, 0.5, 1.5, 2)};
              color: ${theme.colors.critical50};
              font-weight: ${theme.font.weight.semibold};
            `}
          >
            <span css={{ gridColumn: 'span 3' }}>Error Showing Weave Notifications</span>
          </header>

          <div
            css={{
              width: '100%',
              display: 'inline-grid',
              gridTemplateColumns: '2fr 1fr',
            }}
          >
            <div
              css={css`
                -webkit-box-orient: vertical;
                display: flex;
                flex-direction: column;
                grid-column: span 1;
                margin: ${theme.spacing(2)};
                overflow-y: auto;
                text-align: left;
                max-height: 80px;
              `}
            >
              <p css={{ fontWeight: theme.font.weight.semibold, margin: 0, marginBottom: theme.spacing(1) }}>
                {(error as Error)?.message || 'An unexpected error occurred'}
              </p>
              {/* <pre
              css={css`
                margin: 0;
                font-size: 0.75rem;
                white-space: pre-wrap;
                color: ${theme.colors.neutral60};
                overflow-y: auto;
              `}
            >
              {stack || ''}
            </pre> */}
            </div>
            <div
              css={css`
                border-left: 1px solid ${theme.colors.neutral10};
                display: flex;
                flex-direction: column;
                height: 100%;
                justify-content: center;
              `}
            >
              <button
                onClick={handleDismiss}
                css={css`
                  padding: ${theme.spacing(1, 2)};
                  font-weight: ${theme.font.weight.bold};
                  height: 100%;
                  width: 100%;
                  color: ${theme.colors.primary50};
                  background: none;
                  border: none;
                  cursor: pointer;

                  &:hover {
                    background-color: ${theme.colors.neutral5};
                  }
                `}
              >
                Dismiss
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return <Sentry.ErrorBoundary fallback={(props) => <ErrorDisplay {...props} />}>{children}</Sentry.ErrorBoundary>;
};
